import './AboutUsHero.css'
import SpecialtiesHero from '../../Specialties/SpecialtiesHero/SpecialtiesHero'
import { useAppContext } from '../../../context/AppState/AppContext'


export default function AboutUsHero() {
    const {jsonTexts, jsonMedia} = useAppContext();
    const {heroDescription, title} = jsonTexts.aboutUs.aboutUsHero;
   const heroImg = jsonMedia?.institutional?.heroImage
    return (
        <SpecialtiesHero imageUrl={heroImg} height={250} right='10%' title={title}
                         description={heroDescription}/>
    )
}
